export * from './LabelPart';
